import React from 'react'
import Layout from './Layout'

export * from './Layout'
export default React.memo(Layout)
